import { render, staticRenderFns } from "./bansos.vue?vue&type=template&id=1f495307"
import script from "./bansos.vue?vue&type=script&lang=js"
export * from "./bansos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports